export function FullPageLoading({ label = "Einen Moment …" }: { label?: string }) {
  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--ink-soft)",
        fontFamily: "var(--f-body)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 14,
        }}
      >
        <div
          aria-hidden
          style={{
            height: 32,
            width: 32,
            borderRadius: "50%",
            border: "2px solid rgba(43,26,15,0.15)",
            borderTopColor: "var(--oxblood)",
            animation: "vita-spin 700ms linear infinite",
          }}
        />
        <p
          style={{
            margin: 0,
            fontFamily: "var(--f-body)",
            fontStyle: "italic",
            fontSize: 15,
            color: "var(--ink-soft)",
          }}
        >
          {label}
        </p>
        <style>{`@keyframes vita-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}

export function InlineSpinner() {
  return (
    <span
      style={{
        height: 16,
        width: 16,
        borderRadius: "50%",
        border: "2px solid rgba(244,236,216,0.5)",
        borderTopColor: "var(--paper-50)",
        display: "inline-block",
        verticalAlign: "-2px",
        animation: "vita-spin 700ms linear infinite",
      }}
    />
  );
}
